const e=async(e,t,n)=>{let{data:r}=await e.post(`/apps/${t}/terms`,n);return r};export{e as createTerms};
//# sourceMappingURL=create-terms.mjs.map